<template>
	<div class="listOperation">
		<div style="position:relative">
			<img class="done" :class="{'visibility': edit}" src="../assets/img/member/done.png" alt="" @click="done">
			<img class="clear" :class="{'visibility': edit}" src="../assets/img/member/clear.png" alt="" @click="clear">
			<img class="edit" :class="{'visibility': !edit}" src="../assets/img/member/edit.png" alt="" @click="changeStatus">
		</div>
		<system-confirm :text="text" :show.sync="show" @handleConfirm="confirmClear"></system-confirm>
	</div>

</template>

<script>
	import SystemConfirm from './SystemConfirm'
	export default {
		name: 'listOperate',
		components: {
			SystemConfirm
		},
		data() {
			return {
				edit: false, // 是否是编辑状态
				text: '确认删除全部吗?', //提示文字
				show: false, // 确认弹框
			}
		},
		methods: {
			// 点击编辑
			changeStatus() {
				this.edit = !this.edit
				this.$emit('handleEdit')
			},
			// 完成
			done () {
				this.edit = !this.edit
				this.$emit('handleDone')
			},
			// 点击清空
			clear () {
				this.show = true
			},
			// 确认清空
			confirmClear() {
				this.edit = false
				this.$emit('handleClear')
			},
		}
	};
</script>

<style lang="less" scoped>
	.listOperation {
		position: fixed;
		/*display: flex;*/
		/*flex-direction: column;*/
		text-align: center;
		cursor: pointer;
		width: 70px;
		min-height: 70px;
		right: 16px;
		bottom: 16px;
		img {
			position: absolute;
			width: 70px;
			height: 70px;
			top: 0px;
			left: 0;
			visibility: hidden;
		}
		.visibility {
			visibility: visible;
		}
		img.clear {
			transition: top 0.5s;
		}
		.clear.visibility {
			top: -70px;
		}
	}
</style>
